import React, { useState, useReducer, useContext, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";

import './App.css'
import ApartmentViewer from "./components/ApartmentViewer";

import AppDataProviderSelectorComponent from "./components/functional-components/AppDataProviderSelectorComponent";
import ConfigurationStateProvider from "./store/configurationState/ConfigurationStateProvider";
import ConfigurationUrlParamsHandler from "./components/functional-components/ConfigurationUrlParamsHandler";

import FontProvider from "./logic/FontProvider";

import CommonUiOverlayComponent from "./components/ui/CommonUiOverlayComponent";
import { DataProviderContextEnum } from "./enums/DataProviderContextEnum";
import CommandToolBarComponent from "./components/ui/CommandToolBarComponent";
import DocumentManagerUiComponent from "./components/functional-components/DocumentManagerUiComponent";
import CommandLauncherComponent from "./components/functional-components/CommandLauncherComponent";
import CommandIdEnum from "./enums/CommandIdEnums";
import ChecklistItemViewRouteComponent from "./components/route-components/ChecklistItemViewRouteComponent";
import FocusOnBimObjectComponent from "./components/functional-components/FocusOnBimObjectComponent";
import SceneObjectScopeComponent from "./components/functional-components/SceneObjectScopeComponent";
import { useViewerStateStore } from "./store/viewerStateStore";

const SELECT_ONLY = [{ commandId: CommandIdEnum.Select }];
const NO_SCOPED_UUIDS: string[] = [];

function App() {

  const { t } = useTranslation();
  const { isDebugMode } = useViewerStateStore();
  const [ fontProviderInitialized, setFontProviderInitialized ] = useState(false);

  // Get the font provider instance so it starts loading the font rightaway
  // This is needed to ensure that the font is loaded before it is used in the application
  useEffect(() => {
    FontProvider.getInstance().then(() => setFontProviderInitialized(true));
  }, []);

  if (!fontProviderInitialized) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <>
      {/* <p></p> */}
        <div className="mainPage">

          {/* ConfigurationStateProvider provides configuration context to the app */}

          <ConfigurationStateProvider>

                <Router>
                <ConfigurationUrlParamsHandler /> {/* Parses url configuration params and sets them to config context */}
                  <Routes>

                      <Route path="/projects/:projectGlobalId/spatial-structures/:spatialStructureGlobalId" element={
                        <>
                          <AppDataProviderSelectorComponent dataProviderContext={DataProviderContextEnum.Common} />
                          <ApartmentViewer/>
                          <CommandToolBarComponent />
                          <CommandLauncherComponent commands={SELECT_ONLY} />
                          </>
                        }/>

                      <Route path="/projects/:projectGlobalId/apartments/:apartmentGlobalId" element={
                        <>
                          <AppDataProviderSelectorComponent dataProviderContext={DataProviderContextEnum.Common}/>
                          <ApartmentViewer />
                          <CommandToolBarComponent />
                          <CommandLauncherComponent commands={SELECT_ONLY} />
                          </>
                        }/>

                      <Route path="/apartment" element={
                        <>
                          <AppDataProviderSelectorComponent dataProviderContext={DataProviderContextEnum.Common}/>
                          <ApartmentViewer />
                          <CommandToolBarComponent />
                          <CommandLauncherComponent commands={SELECT_ONLY} />
                        </>
                          }/>

                       <Route path="/checklist-item/add" element={
                        <>
                          <AppDataProviderSelectorComponent dataProviderContext={DataProviderContextEnum.Checklist}/>
                          <SceneObjectScopeComponent uuids={NO_SCOPED_UUIDS} />
                          <ApartmentViewer />
                          <FocusOnBimObjectComponent urlParamName="roomUuid" />
                          <CommandLauncherComponent commands={[
                            { commandId: CommandIdEnum.AddChecklistItem },
                          ]} />
                        </>
                          }/>

                      <Route path="/checklist-item/:checklistItemId" element={
                        <>
                          <ChecklistItemViewRouteComponent />
                          <CommandLauncherComponent commands={SELECT_ONLY} />
                        </>
                      } />


                  </Routes>
                </Router>

                {isDebugMode && <DocumentManagerUiComponent />}
                <CommonUiOverlayComponent />


            </ConfigurationStateProvider>

        </div>
    </>
  )
}

export default App
